import { cn } from "@/modules/lib/utils"
import { word } from "@modules/core/utils/i18n"
import { capitalizeAndLowercase } from "@modules/utils/stringUtils"
import { Text } from "@/components/ui/baseUi/text"

export type HuBioCardProps = {
  description: string | null
  job: string | null
  category: string | null
  age: number | null
  height: number | null
  weight: number | null
  className?: string
} & React.ComponentProps<"div">

export function HuBioCard({
  description = "",
  job = "",
  category = "",
  age = null,
  height = null,
  weight = null,
  className,
  ...props
}: HuBioCardProps) {
  //

  return (
    <div
      className={cn(
        "mx-auto flex w-[94%] flex-col gap-4 overflow-hidden rounded-3xl bg-linear-to-br from-green-800 to-green-600",
        className,
      )}
      {...props}
    >
      <Text fontStyle="BM" className="text-center text-white">
        {word("huBioCard.bio")}
      </Text>

      <div className="flex flex-col">
        <Text className="text-white uppercase" fontStyle="BS">
          {word("huBioCard.description")}
        </Text>
        <Text fontStyle="BS" className="text-white">
          {description ?? "--"}
        </Text>
      </div>

      <div className="flex justify-between">
        <div className="flex w-6 flex-col">
          <Text className="text-white uppercase" fontStyle="BS">
            {word("huBioCard.job")}
          </Text>
          <Text fontStyle="TS" className="text-white">
            {job ?? "--"}
          </Text>
        </div>
        <div className="flex flex-col items-end">
          <Text className="text-white uppercase" fontStyle="BS">
            {word("huBioCard.category")}
          </Text>
          <Text fontStyle="TS" className="text-white">
            {category ? capitalizeAndLowercase(category) : "--"}
          </Text>
        </div>
      </div>

      <div className="flex justify-between">
        <div className="flex flex-col">
          <Text className="text-white uppercase" fontStyle="BS">
            {word("huBioCard.age")}
          </Text>
          <Text fontStyle="TS" className="text-white">
            {age && age !== 0 ? age : "--"}
          </Text>
        </div>
        <div className="flex flex-col items-center">
          <Text className="text-white uppercase" fontStyle="BS">
            {word("huBioCard.height")}
          </Text>
          <Text fontStyle="TS" className="text-white">
            {height ? `${height} cm` : "--"}
          </Text>
        </div>
        <div className="flex flex-col items-end">
          <Text className="text-white uppercase" fontStyle="BS">
            {word("huBioCard.weight")}
          </Text>
          <Text fontStyle="TS" className="text-white">
            {weight ? `${weight} kg` : "--"}
          </Text>
        </div>
      </div>
    </div>
  )
}
